module.exports = __webpack_public_path__ + "img/sinPoliza.7555d838.png";